import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import { Icons } from '../assets/icons'
import { useInventory } from '../hooks/useInventory'
import { usePoints } from '../hooks/usePoints'

/**
 * All-time BR1 Points earned from activation, plus the current rate and somewhere to spend them.
 *
 * Replaces the old epoch panel. Epochs are gone: the window handed to the API is now all-time
 * (see hooks/useStakeWindow), so this is a number that keeps growing rather than one pinned to a
 * season that closed in 2024.
 */
export const PointsSummary = () => {
    const { points, rate } = usePoints()
    const { active } = useInventory()

    const display = (Math.floor(points * 100) / 100).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })

    return (
        <div className='flex flex-col md:flex-row md:items-center gap-4 md:gap-6 p-4 md:p-6 border border-white/20 rounded'>
            {/* Icon sits beside the figure at every width. Stacking it above left a tall band of
                dead space on mobile before the label even started. */}
            <div className='flex flex-row items-center gap-4 flex-1 min-w-0'>
                <Icons.SkullPoint className='h-12 w-12 md:h-16 md:w-16 shrink-0' />

                <div className='flex flex-col min-w-0'>
                    <small className='uppercase text-white/50 font-bold tracking-wide'>BR1 Points earned</small>
                    <div className='flex flex-row items-baseline gap-2'>
                        <span className='text-3xl md:text-5xl font-black tabular-nums'>{display}</span>
                        <small className='font-bold text-white/50'>POINTS</small>
                    </div>
                    {/* Terser on mobile so it stays a single line beside the icon. */}
                    <small className='font-bold text-white/60 uppercase text-xs md:text-sm'>
                        {rate > 0 ? (
                            <>
                                {rate.toLocaleString('en-US')} pts / day
                                <span className='hidden md:inline'>
                                    {' '}
                                    from {active.length} {active.length === 1 ? 'active item' : 'active items'}
                                </span>
                                <span className='md:hidden'> · {active.length} active</span>
                            </>
                        ) : (
                            <>Nothing active yet</>
                        )}
                    </small>
                </div>
            </div>

            <Link
                to='/store'
                className='shrink-0 w-full md:w-auto bg-br1-gradient hover:brightness-125 rounded px-8 py-3 md:py-3.5 min-h-[2.75rem] font-black uppercase tracking-widest text-center flex flex-row items-center justify-center gap-3'
            >
                <span>Spend in store</span>
                <FontAwesomeIcon icon={faArrowRight} />
            </Link>
        </div>
    )
}
